var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { EventEmitter, NgModule, } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AbstractDestructionSubject } from './abstract-destruction-subject';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs/Observable';
export var DynamicLayoutType;
(function (DynamicLayoutType) {
    DynamicLayoutType[DynamicLayoutType["form"] = 0] = "form";
    DynamicLayoutType[DynamicLayoutType["page"] = 1] = "page";
    DynamicLayoutType[DynamicLayoutType["subForm"] = 2] = "subForm";
    DynamicLayoutType[DynamicLayoutType["workflowForm"] = 3] = "workflowForm";
})(DynamicLayoutType || (DynamicLayoutType = {}));
var DynamicLayout = /** @class */ (function (_super) {
    __extends(DynamicLayout, _super);
    function DynamicLayout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validationsChanged = new Subject();
        _this.readyToDrawComponents = new EventEmitter();
        _this._moduleSet = new Set();
        _this._componentCache = new Map();
        return _this;
    }
    DynamicLayout.prototype.getRuntimeModuleRef = function () {
        return this._runtimeRef;
    };
    DynamicLayout.prototype.getRuntimeComponentFactory = function (controlModelId) {
        var _this = this;
        return this._runtimeModuleWithFactory.componentFactories.find(function (f) { return f.componentType === _this._componentCache.get(controlModelId); });
    };
    DynamicLayout.prototype.loadRuntimeModule = function () {
        /* tslint:disable:max-classes-per-file*/
        var _this = this;
        var moduleSet = this._moduleSet;
        var componentCache = this._componentCache.values();
        var RuntimeComponentModule = /** @class */ (function () {
            function RuntimeComponentModule() {
            }
            RuntimeComponentModule = __decorate([
                NgModule({
                    imports: [FormsModule, CommonModule].concat(Array.from(moduleSet)),
                    declarations: Array.from(componentCache).slice(),
                })
            ], RuntimeComponentModule);
            return RuntimeComponentModule;
        }());
        /* tslint:enable:max-classes-per-file*/
        return Observable.fromPromise(this.compiler.compileModuleAndAllComponentsAsync(RuntimeComponentModule)).map(function (module) {
            _this._runtimeModuleWithFactory = module;
            _this._runtimeRef = module.ngModuleFactory.create(_this.injector);
            _this.readyToDrawComponents.next();
        });
    };
    return DynamicLayout;
}(AbstractDestructionSubject));
export { DynamicLayout };
//# sourceMappingURL=dynamic-layout.js.map